import './ColorPicker.scss'

import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react'

import Dropdown from '../Dropdown/Dropdown'
import { SwatchesPicker } from 'react-color'
import { formEvent } from '../Form/Form'

const ColorPicker = ({ name, label, initialValue, required, onChange }) => {
  const [color, setColor] = useState({ hex: initialValue || '#1c194d' })
  const element = useRef()

  const sendColor = useCallback(() => {
    element.current.dispatchEvent(
      formEvent({
        action: 'UPDATE',
        name,
        value: color.hex
      })
    )
    if (onChange) onChange(color.hex)
  }, [name, color, onChange])

  useEffect(() => {
    if (name) {
      element.current.dispatchEvent(
        formEvent({
          action: 'REQUIRED',
          name,
          required
        })
      )
    }
  }, [name, required])

  useEffect(() => {
    const _element = element.current
    return () => {
      if (name) {
        _element.dispatchEvent(
          formEvent({
            action: 'REMOVE',
            name
          })
        )
      }
    }
  }, [name])

  useEffect(sendColor, [sendColor])

  return (
    <div ref={element} className='color-picker'>
      <Dropdown button={<ButtonPicker label={label} color={color} />} basic>
        <SwatchesPicker color={color} onChange={setColor} />
      </Dropdown>
    </div>
  )
}

const ButtonPicker = ({ label, color }) => (
  <Fragment>
    <div className="-color" style={{ backgroundColor: color.hex}}></div>
    <label className="-label text-label">{label}</label>
  </Fragment>
)

export default ColorPicker
